<nz-row nzGutter="24">
  <nz-col [nzSm]="24">
    <d-date-picker
      [nzShowTime]="true"
      nzFormat="yyyy-MM-dd HH:mm:ss"
      name="value"
      #nameInput="ngModel"
      [(ngModel)]="config.value"
      [required]="config.required"
      style="width: 100%"
    ></d-date-picker>
  </nz-col>
  <nz-col [nzSm]="24" *ngIf="config.effective">
    <app-effective-display [config]="config"> </app-effective-display>
  </nz-col>
</nz-row>
